// TODO we should use downshift instead of AutocompleteDegreeField

import React from 'react';
import PropTypes from 'prop-types';

import LabeledField from '../LabeledField';
import AutocompleteDegreeField from '../DegreeField';

import '@static/css/light/vendor/zipAutocomplete.css';

import {
  STRING_FIELD_EDUCATION_DEGREE,
} from '../labels';

import formikPropTypes from './formikPropTypes';

export function DegreeField({
  name, formikProps: {
    errors, handleChange, isSubmitting, setFieldValue, touched, values,
  },
}) {
  // note: select returns the value, not the event
  const handleSelect = (value) => {
    setFieldValue(name, value);
  };

  return (
    <LabeledField
      as={AutocompleteDegreeField}
      input={{
        disabled: isSubmitting,
        name,
        onChange: handleChange,
        value: values[name] || '',
      }}
      label={STRING_FIELD_EDUCATION_DEGREE}
      meta={{
        error: errors[name],
        touched: touched[name],
      }}
      name={name}
      placeholder={STRING_FIELD_EDUCATION_DEGREE}
      onSelect={handleSelect}
    />
  );
}

DegreeField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default DegreeField;
